import type { WhoRound } from "../puzzles/types";

/** Accent-, case- and punctuation-insensitive form used for answer matching. */
export function normalize(s: string): string {
  return s
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/ł/g, "l")
    .replace(/Ł/g, "L")
    .replace(/ß/g, "ss")
    .replace(/[øØ]/g, "o")
    .replace(/[æÆ]/g, "ae")
    .toLowerCase()
    .replace(/[^a-z0-9 ]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

/** True if the guess matches the answer or any alias. */
export function isCorrectWho(guess: string, round: Pick<WhoRound, "answer" | "aliases">): boolean {
  const g = normalize(guess);
  if (!g) return false;
  return [round.answer, ...round.aliases].some((a) => normalize(a) === g);
}
